export default __webpack_public_path__ + "static/media/logo_braulio.c40dcb2a.png";